export const MediaTypeEnum = Object.freeze({
    image: 'Image',
    video: 'Video',
});